var SectionLoadMore = (function ($) {
  var $els = {};

  var init = () => {
    _initDOM();
    _addListeners();
  };

  var _initDOM = () => {
    $els.loadMoreSections = $(".wg-load-more");
  };

  var _addListeners = () => {
    $.each($els.loadMoreSections, (i, val) => {
      let $this = $(val);
      let $loadMoreBtn = $this.find(".btn-load-more");

      $loadMoreBtn.on("click", (e) => {
        let $groupsRemaining = $this.find(".lm-group.hidden").length;
        let $nextGroup = $this.find(".lm-group.hidden").eq(0);
        $nextGroup.removeClass("hidden");

        if ($groupsRemaining === 1) {
          $loadMoreBtn.hide();
        }
        setTimeout(() => {
          $nextGroup.addClass("fadein");
        }, 100);
      });
    });
  };

  module.exports = {
    init: init,
  };
})(jQuery);
